export default {
    getCurrentCustomer: {
        url: '/base/basecustomer/getCurrentCustomerInfo',
        method: 'get'
    },
    trainHistoryList: {
        url: '/base/basecustomerclass/trainHistoryList',
        method: 'get'
    },
    myCustomerAnalysis: {
        url: '/base/basecustomer/myCustomerAnalysis',
        method: 'get'
    },
    customerTrackAnalysis: {
        url: '/base/basecustomer/customerTrackAnalysis',
        method: 'get'
    }

}
